export const TIPOS_SISTEMA = [
    { value: '', name: 'SELECIONE...' },
    { value: 'financeiro', name: 'Financeiro' },
    { value: 'inseminadores', name: 'Inseminadores' },
    { value: 'zootecnico', name: 'Zootécnico' }
];

export default TIPOS_SISTEMA;